import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EventService } from '@reg/shared/service';
import { Event } from '@reg/shared/model';

/**
 * Component to display the wizard steps provided by the WizardStepService
 */
@Component({
    selector: 'flo-event-header',
    templateUrl: './event-header.component.html',
    styleUrls: ['./event-header.component.scss'],
})
export class EventHeaderComponent implements OnInit {
    @Input() public title: string;

    public event: Event;
    public eventId: string;

    /**
     * Constructor
     */
    constructor(
                private activatedRoute: ActivatedRoute,
                private eventService: EventService,
    ) {
    }

    /**
     * Get the event so we can give it to the WizardStepService to determine
     * what steps should be displayed.
     */
    public ngOnInit(): void {
        this.eventId = this.activatedRoute.snapshot.parent.params['event-id'];

        if (this.eventId) {
            this.eventService.get(this.eventId).subscribe((event: Event) => {
                this.event = event;
            });
        }
    }
}
